import { ConfirmScores } from './ConfirmScores';

export default ConfirmScores;
